/* Atelier Loreti - hero: the fracture (canvas), a light that follows the hand, the watch in depth, the edition switch.
   The HERO engine below is carried over from the landing page unchanged; the section wiring follows it. */
const A = window.Atelier;
  var HERO = (function () {
  function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function ss(a, b, x) { var t = cl((x - a) / (b - a)); return t * t * (3 - 2 * t); }
  function rng(seed) { seed = seed % 2147483647; if (seed <= 0) seed += 2147483646; return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  var EASE = {
    io: { f: function (x) { return 0.5 - 0.5 * Math.cos(Math.PI * x); }, inv: function (u) { return Math.acos(1 - 2 * u) / Math.PI; } },
    out: { f: function (x) { return 1 - Math.pow(1 - x, 3); }, inv: function (u) { return 1 - Math.cbrt(1 - u); } }
  };
  var END = 8.6;
  /* Skeleton in units of U (height of the watch photograph), relative to the case centre.
     The trunk enters from the top, passes behind the case and leaves lower right; branch B
     is the wide vein that the scroll camera travels into. */
  var DEFS = [
    { seed: 11, t0: 1.2, dur: 5.0, e: 'io', w: .0125, tip: 0, pts: [[-0.44,-0.80],[-0.37,-0.58],[-0.335,-0.44],[-0.275,-0.31],[-0.2,-0.17],[0,0.04],[0.18,0.19],[0.285,0.275],[0.35,0.38],[0.405,0.53],[0.46,0.70],[0.53,0.92]] },
    { seed: 23, t0: 2.5, dur: 2.3, e: 'out', w: .0075, tip: 1, pts: [[-0.355,-0.51],[-0.47,-0.47],[-0.6,-0.55],[-0.78,-0.52],[-0.97,-0.61]] },
    { seed: 31, t0: 3.0, dur: 1.3, e: 'out', w: .0045, tip: 1, pts: [[-0.28,-0.32],[-0.2,-0.37],[-0.155,-0.45]] },
    { seed: 41, t0: 4.0, dur: 3.0, e: 'out', w: .027, tip: 1, pts: [[0.285,0.275],[0.42,0.235],[0.55,0.27],[0.68,0.22],[0.82,0.17],[1.02,0.21],[1.25,0.11],[1.5,0.14]] },
    { seed: 53, t0: 4.7, dur: 1.6, e: 'out', w: .0058, tip: 1, pts: [[0.405,0.53],[0.33,0.61],[0.24,0.70],[0.2,0.8]] },
    { seed: 61, t0: 5.0, dur: 2.7, e: 'out', w: 0, hair: .34, tip: 1, pts: [[-0.6,-0.55],[-0.72,-0.38],[-0.86,-0.2],[-1.1,-0.05]] },
    { seed: 67, t0: 5.4, dur: 2.5, e: 'out', w: 0, hair: .3, tip: 1, pts: [[0.82,0.17],[0.9,0.0],[0.96,-0.2],[1.12,-0.45]] },
    { seed: 71, t0: 3.4, dur: 2.1, e: 'out', w: 0, hair: .26, tip: 1, pts: [[-0.335,-0.44],[-0.43,-0.33],[-0.5,-0.2],[-0.66,-0.1]] }
  ];
  function spline(P, step) {
    var out = [];
    for (var i = 0; i < P.length - 1; i++) {
      var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(P.length - 1, i + 2)];
      var n = Math.max(2, Math.ceil(Math.hypot(p2[0] - p1[0], p2[1] - p1[1]) / step));
      for (var j = 0; j < n; j++) {
        var t = j / n, t2 = t * t, t3 = t2 * t, o = [];
        for (var d = 0; d < 2; d++) o.push(0.5 * (2 * p1[d] + (-p0[d] + p2[d]) * t + (2 * p0[d] - 5 * p1[d] + 4 * p2[d] - p3[d]) * t2 + (-p0[d] + 3 * p1[d] - 3 * p2[d] + p3[d]) * t3));
        out.push(o);
      }
    }
    out.push(P[P.length - 1].slice());
    return out;
  }
  function fractal(P, r, levels, amp) {
    for (var L = 0; L < levels; L++) {
      var o = [P[0]];
      for (var i = 0; i < P.length - 1; i++) {
        var a = P[i], b = P[i + 1], dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy) || 1e-6;
        var d = (r() - 0.5) * 2 * amp * len;
        o.push([(a[0] + b[0]) / 2 - dy / len * d, (a[1] + b[1]) / 2 + dx / len * d]);
        o.push(b);
      }
      P = o; amp *= 0.56;
    }
    return P;
  }
  function build(def, parent) {
    var r = rng(def.seed * 7919 + 13);
    var P = fractal(spline(def.pts, 0.025), r, 4, 0.26);
    var N = P.length, s = new Float32Array(N), tot = 0, i;
    for (i = 1; i < N; i++) { tot += Math.hypot(P[i][0] - P[i - 1][0], P[i][1] - P[i - 1][1]); s[i] = tot; }
    var ph = []; for (i = 0; i < 6; i++) ph.push(r() * 6.283);
    var F = function () { return new Float32Array(N); };
    var c = { def: def, N: N, x: F(), y: F(), nx: F(), ny: F(), u: F(), w: F(), jl: F(), jr: F(), reach: F(), hw: F(), X: F(), Y: F() };
    for (i = 0; i < N; i++) {
      c.x[i] = P[i][0]; c.y[i] = P[i][1];
      var u = s[i] / tot; c.u[i] = u;
      var a = P[Math.max(0, i - 9)], b = P[Math.min(N - 1, i + 9)], dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy) || 1;
      c.nx[i] = -dy / l; c.ny[i] = dx / l;
      var sl = s[i] / 0.01;
      var nz = 0.55 * Math.sin(sl * 0.9 + ph[0]) + 0.3 * Math.sin(sl * 2.3 + ph[1]) + 0.15 * Math.sin(sl * 5.1 + ph[2]);
      var taper = def.tip ? Math.pow(1 - u, 0.75) * 0.9 + 0.1 : 1;
      c.w[i] = def.w * taper * (1 + 0.55 * nz);
      c.jl[i] = 0.84 + 0.2 * Math.sin(sl * 0.55 + ph[3]) + 0.1 * Math.sin(sl * 1.7 + ph[5]) + 0.05 * Math.sin(sl * 4.1 + ph[1]) + 0.04 * (r() - 0.5);
      c.jr[i] = 0.84 + 0.2 * Math.sin(sl * 0.7 + ph[4]) + 0.1 * Math.sin(sl * 1.9 + ph[0]) + 0.05 * Math.sin(sl * 3.7 + ph[2]) + 0.04 * (r() - 0.5);
    }
    var t0 = def.t0;
    if (parent) { // a branch opens only once the trunk has reached its root
      var best = 0, bd = 1e9;
      for (i = 0; i < parent.N; i++) { var dd = Math.hypot(parent.x[i] - c.x[0], parent.y[i] - c.y[0]); if (dd < bd) { bd = dd; best = i; } }
      if (bd < 0.03) t0 = Math.max(t0, parent.reach[best] + 0.06);
    }
    c.t0 = t0;
    var E = EASE[def.e];
    for (i = 0; i < N; i++) c.reach[i] = t0 + def.dur * E.inv(c.u[i]);
    c.ease = E;
    return c;
  }

  function mount(el, opt) {
    var st = el.stage, cv = el.crack, gv = el.glow;
    var ctx = cv.getContext('2d'), gtx = gv.getContext('2d');
    if (!ctx) return null;
    var reduce = !!opt.reduce, lite = !!opt.lite;
    var trunk = build(DEFS[0], null), cracks = [trunk], i;
    for (i = 1; i < DEFS.length; i++) cracks.push(build(DEFS[i], trunk));
    var B = cracks[3], bi = 0, bd = 1e9;
    for (i = 0; i < B.N; i++) { var d0 = Math.hypot(B.x[i] - 0.55, B.y[i] - 0.27); if (d0 < bd) { bd = d0; bi = i; } }
    // the stone inside the fracture follows the edition on show: Charoite, or snowflake obsidian
    var SRC = {}, cur = 'cha', prev = null, mix = 1;
    function load(k, src, flt, sc, lift) {
      var S = SRC[k] = { img: new Image(), ok: false, pat: null, flt: flt, sc: sc, lift: lift };
      S.img.onload = function () { S.ok = true; try { S.pat = ctx.createPattern(S.img, 'repeat'); } catch (e) { S.pat = null; } cacheOk = false; request(); };
      S.img.src = src;
    }
    load('cha', opt.charoite, 'saturate(1.08) brightness(1.08) contrast(1.12)', 1, null);
    if (opt.obsidian) load('obs', opt.obsidian, 'contrast(1.3) brightness(1.7)', 1.3, 'rgba(110,114,130,.34)'); // the black glass is lifted so its flakes read in the dark
    var W = 0, H = 0, dpr = 1, U = 0, ax = 0, ay = 0, sx = 1;
    // the next chapter sits beneath the hero only where scroll-driven animation holds its first frame
    var overlap = !reduce;
    var T = reduce ? END : 0, speed = 1, last = 0, raf = 0, playing = false, done = reduce, q = 0, slow = 0, frames = 0;
    var parts = [], pr = rng(97);
    // cursor light: the fracture brightens under the pointer, and touching it sends light travelling through the whole network
    var mx = 0, my = 0, mxT = 0, myT = 0, offX = 0, offY = 0, fine = !!(window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches);
    var hov = 0, hovT = 0, plx = -1e5, ply = -1e5, psx = -1e5, psy = -1e5, pulses = [], lastPulse = -9, clock = 0, camK = 1, camX = 0, camY = 0;

    var cache = null, cacheOk = false;
    function measure() {
      cacheOk = false;
      var r = st.getBoundingClientRect();
      W = r.width; H = r.height;
      dpr = Math.min(window.devicePixelRatio || 1, lite ? 1 : 1.75);
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      gv.width = Math.max(1, Math.round(W / 2)); gv.height = Math.max(1, Math.round(H / 2));
      U = el.wrap.offsetHeight; ax = el.anchor.offsetLeft; ay = el.anchor.offsetTop;
      sx = Math.min(1, Math.max(0.62, W / (U * 1.3))); // narrow screens: draw the network closer to the case
    }
    function prog() {
      if (reduce) return 0;
      var r = el.track.getBoundingClientRect(), span = r.height - H;
      return span > 1 ? cl(-r.top / span) : 0;
    }
    function band(g, c, n, f, off, add) {
      var i, hw = c.hw;
      g.beginPath();
      for (i = 0; i <= n; i++) {
        var o = -off * hw[i], e = hw[i] * f * c.jl[i] + add;
        var px = c.X[i] + c.nx[i] * (o + e), py = c.Y[i] + c.ny[i] * (o + e);
        if (i) g.lineTo(px, py); else g.moveTo(px, py);
      }
      for (i = n; i >= 0; i--) {
        var o2 = -off * hw[i], e2 = hw[i] * f * c.jr[i] + add;
        g.lineTo(c.X[i] + c.nx[i] * (o2 - e2), c.Y[i] + c.ny[i] * (o2 - e2));
      }
      g.closePath();
    }
    function line(g, c, a, n, side) {
      g.beginPath();
      for (var i = a; i <= n; i++) {
        var e = side ? (side > 0 ? c.hw[i] * 0.5 * c.jl[i] : -c.hw[i] * 0.5 * c.jr[i]) : 0;
        var px = c.X[i] + c.nx[i] * e, py = c.Y[i] + c.ny[i] * e;
        if (i > a) g.lineTo(px, py); else g.moveTo(px, py);
      }
    }
    function glass() { return cur === 'obs' ? (prev ? mix : 1) : (prev === 'obs' ? 1 - mix : 0); }
    function stone(g, m) { // the stone plane sits slightly deeper than the rock: it drifts a little less
      if (prev && mix < 1) { one(g, m, SRC[prev], 1); one(g, m, SRC[cur], mix); } else one(g, m, SRC[cur], 1);
    }
    function one(g, m, S, a) {
      if (!S || !S.ok) return;
      var ga = g.globalAlpha; g.globalAlpha = ga * a;
      g.setTransform(dpr * m.Kc, 0, 0, dpr * m.Kc, dpr * m.tcx, dpr * m.tcy);
      if (!lite) g.filter = S.flt;
      var ps = Math.max(0.42, H / 1700) * S.sc; // fibres stay near the photograph's own resolution
      if (S.pat && S.pat.setTransform && window.DOMMatrix) {
        S.pat.setTransform(new DOMMatrix([ps, 0, 0, ps, W * 0.13 - 0.7 * offX, H * 0.07 - 0.7 * offY]));
        g.fillStyle = S.pat; g.fillRect(-W, -H, W * 3, H * 3);
      } else {
        var s = Math.max(W / S.img.width, H / S.img.height) * 1.1, dw = S.img.width * s, dh = S.img.height * s;
        g.drawImage(S.img, (W - dw) / 2 - 0.7 * offX, (H - dh) / 2 - 0.7 * offY, dw, dh);
      }
      g.filter = 'none';
      if (S.lift) { var co = g.globalCompositeOperation; g.globalCompositeOperation = 'screen'; g.fillStyle = S.lift; g.fillRect(-W, -H, W * 3, H * 3); g.globalCompositeOperation = co; }
      g.globalAlpha = ga;
    }
    function draw() {
      if (!W) return;
      var k1 = 1; // the rock behind the watch no longer zooms in
      /* Scroll no longer zooms. The hero holds still and dissolves into the next chapter, which waits
         beneath it already composed: copy leaves first, the watch rises a touch and softens, then the
         stone fades. Opacity, a small translate and a light blur only. */
      var qe = 0.14 * ss(0.04, 0.6, q); // scrolling on, the fracture widens and the light gathers in it
      var K = k1, tx = ax * (1 - k1), ty = ay * (1 - k1);
      var m = { Kc: 1 + (K - 1) * 0.9, tcx: ax * (1 - (1 + (K - 1) * 0.9)), tcy: ay * (1 - (1 + (K - 1) * 0.9)) };
      offX = -12 * mx; offY = -8 * my; // the rock and its fracture sit behind the watch: they drift against the hand
      el.cam.style.transform = 'matrix(' + K + ',0,0,' + K + ',' + (tx + offX).toFixed(2) + ',' + (ty + offY).toFixed(2) + ')';
      cv.style.transform = gv.style.transform = 'translate3d(' + offX.toFixed(2) + 'px,' + offY.toFixed(2) + 'px,0)';
      // the watch comes toward the viewer as the page leaves, then softens away; it follows the hand a little, in depth
      var wf = ss(0.42, 0.86, q), drift = -0.05 * H * ss(0.04, 0.7, q), Kw = K * (1 + 0.07 * ss(0, 0.7, q));
      el.wlayer.style.transform = 'none'; // the watch holds still: no zoom, drift, tilt, blur or fade
      gv.style.opacity = '0'; // no halo around the fracture: the stone carries the colour, not a glow

      var G = 1.35 * (1 + 0.3 * ss(5, 8.4, T) + 2.0 * qe); // wider openings: the Charoite reads from across the room
      var bxu = B.x[bi], byu = B.y[bi], local = 0;
      var base = [dpr * K, 0, 0, dpr * K, dpr * tx, dpr * ty], px = 1 / K;
      camK = K; camX = tx + offX; camY = ty + offY;
      plx = (psx - offX - tx) / K; ply = (psy - offY - ty) / K;
      var lit = hov > 0.01 || pulses.length > 0;
      if (el.torch) { // the cursor rakes light across the rock surface itself
        el.torch.style.opacity = (0.66 * hov).toFixed(3);
        if (hov > 0.01) { el.torch.style.setProperty('--tx', (plx + 0.02 * W).toFixed(1) + 'px'); el.torch.style.setProperty('--ty', (ply + 0.02 * H).toFixed(1) + 'px'); }
      }
      var still = done && !playing && parts.length === 0 && q < 0.001 && mix >= 1;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
      if (still && cacheOk) {
        ctx.drawImage(cache, 0, 0);
        if (lit) for (var lc = 0; lc < cracks.length; lc++) {
          var cc = cracks[lc];
          if (cc.def.w > 0 && cc.lastN > 2) { ctx.save(); ctx.setTransform.apply(ctx, base); band(ctx, cc, cc.lastN, 0.5, 0, 0); ctx.clip(); lightFill(1, K); ctx.restore(); }
        }
        return;
      }
      if (!lite) { gtx.setTransform(1, 0, 0, 1, 0, 0); gtx.clearRect(0, 0, gv.width, gv.height); }

      for (var ci = 0; ci < cracks.length; ci++) {
        var c = cracks[ci], def = c.def;
        if (T <= c.t0) continue;
        var uf = c.ease.f(cl((T - c.t0) / def.dur)), n = 0;
        while (n < c.N - 1 && c.u[n + 1] <= uf) n++;
        if (n < 2) continue;
        c.lastN = n;
        for (var i = 0; i <= n; i++) {
          c.X[i] = ax + c.x[i] * U * sx; c.Y[i] = ay + c.y[i] * U;
          var age = T - c.reach[i], open = 0.06 + 0.94 * ss(0.15, 1.8, age);
          var dl = (c.x[i] - bxu) * (c.x[i] - bxu) + (c.y[i] - byu) * (c.y[i] - byu);
          c.hw[i] = c.w[i] * U * open * G * (1 + local * Math.exp(-dl / 0.018));
        }
        var j0 = 0; while (j0 < n && T - c.reach[j0] > 1.7) j0++;
        if (def.w > 0) {
          // only a faint bounce of colour onto the rock, never a neon halo
          
          ctx.setTransform.apply(ctx, base);
          // the rock lip darkens toward the break, softly
          ctx.fillStyle = 'rgba(0,0,0,.18)'; band(ctx, c, n, 0.5, 0, 7 * px); ctx.fill();
          ctx.fillStyle = 'rgba(0,0,0,.34)'; band(ctx, c, n, 0.5, 0, 2.4 * px); ctx.fill();
          // the opening: Charoite at the floor, with soft wall shadow falling in from both edges
          var mw = 0; for (var q2 = 0; q2 <= n; q2++) mw += c.hw[q2]; mw = mw / (n + 1) * 1.1;
          ctx.save(); ctx.setTransform.apply(ctx, base); band(ctx, c, n, 0.5, 0, 0); ctx.clip(); stone(ctx, m);
          ctx.setTransform.apply(ctx, base);
          
          ctx.save(); band(ctx, c, n, 0.2, 0.12, 0); ctx.clip(); ctx.globalCompositeOperation = 'overlay'; ctx.globalAlpha = 0.35; stone(ctx, m); ctx.restore();
          ctx.setTransform.apply(ctx, base);
          if (!lite) ctx.filter = 'blur(' + Math.max(1.2, mw * 0.2 * K * dpr).toFixed(1) + 'px)';
          ctx.lineJoin = 'round';
          // depth: the walls fall away into shadow, and the upper wall casts its shade across half the floor
          var gl = glass(), sh = 1 - 0.35 * gl; // obsidian is glass: lighter walls, and a sheen along the floor
          ctx.strokeStyle = 'rgba(3,2,7,' + (0.85 * sh).toFixed(3) + ')'; ctx.lineWidth = mw * 0.46; band(ctx, c, n, 0.5, 0, 0); ctx.stroke();
          ctx.fillStyle = 'rgba(3,2,7,' + (0.45 * sh).toFixed(3) + ')'; band(ctx, c, n, 0.5, -0.48, 0); ctx.fill();
          ctx.strokeStyle = 'rgba(3,2,7,' + (0.6 * sh).toFixed(3) + ')'; ctx.lineWidth = mw * 0.5; line(ctx, c, 0, n, 1); ctx.stroke();
          if (gl > 0.01) { ctx.strokeStyle = 'rgba(214,222,240,' + (0.55 * gl).toFixed(3) + ')'; ctx.lineWidth = mw * 0.16; line(ctx, c, 0, n, -1); ctx.stroke(); }
          ctx.filter = 'none';
          if (lit) lightFill(1, K);
          ctx.restore();
          ctx.setTransform.apply(ctx, base);
          ctx.lineJoin = 'round'; ctx.lineCap = 'round';
          ctx.strokeStyle = 'rgba(3,2,5,.75)'; ctx.lineWidth = 1 * px; band(ctx, c, n, 0.5, 0, 0); ctx.stroke();
          ctx.strokeStyle = 'rgba(0,0,0,.6)'; ctx.lineWidth = 1.4 * px; line(ctx, c, 0, n, 1); ctx.stroke();
          ctx.strokeStyle = 'rgba(222,216,232,' + (0.24 + 0.3 * glass()).toFixed(3) + ')'; ctx.lineWidth = (0.9 + 0.5 * glass()) * px; line(ctx, c, 0, n, -1); ctx.stroke(); // the lit lip
          if (j0 < n) { ctx.strokeStyle = 'rgba(196,184,220,.28)'; ctx.lineWidth = 0.7 * px; line(ctx, c, j0, n, 0); ctx.stroke(); }
        } else {
          ctx.setTransform.apply(ctx, base);
          ctx.lineCap = 'round'; ctx.strokeStyle = 'rgba(160,152,176,' + (def.hair * 1.1).toFixed(3) + ')'; ctx.lineWidth = 0.8 * px; line(ctx, c, 0, n, 0); ctx.stroke();
        }
        // stone dust shed at the advancing tip, only where the tip is not hidden by the case
        if (!lite && playing && uf < 0.995 && (ci === 0 || ci === 3) && pr() < 0.28 * speed) {
          var tdx = c.x[n], tdy = c.y[n];
          if (tdx * tdx + tdy * tdy > 0.075 && parts.length < 90) parts.push({ x: c.X[n], y: c.Y[n], vx: (pr() - 0.5) * 18, vy: -pr() * 10, t: 0, life: 0.8 + pr() * 0.9, s: 0.5 + pr() * 1.1 });
        }
      }
      if (parts.length) {
        ctx.setTransform.apply(ctx, base);
        for (var p = 0; p < parts.length; p++) { var a = parts[p]; ctx.fillStyle = 'rgba(176,170,186,' + (0.32 * (1 - a.t / a.life)).toFixed(3) + ')'; ctx.fillRect(a.x, a.y, a.s * px, a.s * px); }
      }
      if (still && !lit) { // keep the finished, unlit fracture for replay
        if (!cache) cache = document.createElement('canvas');
        cache.width = cv.width; cache.height = cv.height;
        cache.getContext('2d').drawImage(cv, 0, 0); cacheOk = true;
      }
    }
    var WALL = [[0.5, 0, 0.72], [0.42, 0.04, 0.52], [0.34, 0.08, 0.34], [0.26, 0.11, 0.18], [0.18, 0.14, 0.04]];
    function lightFill(k, K) { // called inside a crack clip: the light falls on the Charoite, not on the air
      ctx.globalCompositeOperation = 'screen';
      if (hov > 0.01) {
        var R = 250 / K, g = ctx.createRadialGradient(plx, ply, 0, plx, ply, R);
        g.addColorStop(0, 'rgba(206,192,236,' + (0.5 * hov * k).toFixed(3) + ')'); g.addColorStop(0.55, 'rgba(150,132,196,' + (0.18 * hov * k).toFixed(3) + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g; ctx.fillRect(plx - R, ply - R, R * 2, R * 2);
      }
      for (var p = 0; p < pulses.length; p++) {
        var P = pulses[p], r = P.t * 520 / K, wd = 90 / K, a = 0.26 * (P.a || 1) * k * Math.exp(-P.t / 1.3) * ss(0, 0.25, P.t);
        if (a < 0.004) continue;
        var g2 = ctx.createRadialGradient(P.x, P.y, Math.max(0, r - wd), P.x, P.y, r + wd);
        g2.addColorStop(0, 'rgba(0,0,0,0)'); g2.addColorStop(0.5, 'rgba(200,188,230,' + a.toFixed(3) + ')'); g2.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g2; ctx.fillRect(P.x - r - wd, P.y - r - wd, (r + wd) * 2, (r + wd) * 2);
      }
      ctx.globalCompositeOperation = 'source-over';
    }
    function nearest(sxp, syp) { // closest revealed fracture point to a screen position, in screen pixels
      var lx = (sxp - camX) / camK, ly = (syp - camY) / camK, best = 1e9, bx = 0, by = 0;
      for (var ci = 0; ci < cracks.length; ci++) {
        var c = cracks[ci]; if (T <= c.t0) continue;
        for (var i = 0; i < c.N; i += 3) {
          if (c.reach[i] > T) break;
          var dx = ax + c.x[i] * U * sx - lx, dy = ay + c.y[i] * U - ly, d = dx * dx + dy * dy;
          if (d < best) { best = d; bx = lx + dx; by = ly + dy; }
        }
      }
      return { d: Math.sqrt(best) * camK, x: bx, y: by };
    }
    function pulseFrom(sxp, syp, reach) {
      if (reduce || clock - lastPulse < 0.7 || pulses.length > 2) return;
      var h = nearest(sxp, syp);
      if (h.d > reach) return;
      lastPulse = clock; pulses.push({ x: h.x, y: h.y, t: 0, a: 1 });
    }
    function onMove(e) {
      if (e.pointerType !== 'mouse') return;
      var r = st.getBoundingClientRect(); psx = e.clientX - r.left; psy = e.clientY - r.top;
      hovT = q < 0.25 ? 1 : 0; mxT = cl(psx / W) * 2 - 1; myT = cl(psy / H) * 2 - 1; pulseFrom(psx, psy, 40); request();
    }
    function onLeave() { hovT = 0; mxT = myT = 0; overW = false; request(); }
    function onDown(e) {
      if (e.pointerType === 'mouse') return;
      var r = st.getBoundingClientRect(); pulseFrom(e.clientX - r.left, e.clientY - r.top, 44); request();
    }
    function stepLight(dt) {
      clock += dt;
      if (q > 0.25) hovT = 0;
      hov += (hovT - hov) * Math.min(1, dt * 5);
      if (mix < 1) { mix = Math.min(1, mix + dt / 1.2); if (mix >= 1) { prev = null; cacheOk = false; } }
      var km = Math.min(1, dt * 3.2); mx += (mxT - mx) * km; my += (myT - my) * km;
      for (var p = pulses.length - 1; p >= 0; p--) { pulses[p].t += dt; if (pulses[p].t > 3) pulses.splice(p, 1); }
    }
    function stepParts(dt) {
      for (var p = parts.length - 1; p >= 0; p--) {
        var a = parts[p]; a.t += dt; a.vy += 70 * dt; a.x += a.vx * dt; a.y += a.vy * dt;
        if (a.t > a.life) parts.splice(p, 1);
      }
    }
    /* The intro clock follows wall time, like the CSS choreography it drives alongside. A throttled or
       background frame loop (hidden tab, off-screen canvas board) used to stall it mid-intro, leaving
       "Skip intro" on screen over a finished hero; a slow timer now keeps it advancing. */
    var lastStep = 0, guard = 0;
    function step(now) {
      var dt = last ? Math.min(12, Math.max(0, (now - last) / 1000)) : 1 / 60; last = now; lastStep = now;
      if (playing) {
        T += dt * speed;
        frames++; if (dt > 0.034 && dt < 0.25) slow++;
        if (frames === 45 && slow > 22 && !lite) { lite = true; measure(); } // fall back on struggling devices
        if (T >= END) finish();
      }
      q = prog(); stepParts(Math.min(dt, 0.1)); stepLight(Math.min(dt, 0.1)); draw();
      return playing || parts.length || pulses.length || Math.abs(hov - hovT) > 0.004 || Math.abs(mx - mxT) + Math.abs(my - myT) > 0.002 || mix < 1;
    }
    function tick(now) {
      raf = 0;
      if (step(now)) raf = requestAnimationFrame(tick);
      else last = 0;
    }
    function request() { if (!raf) raf = requestAnimationFrame(tick); }
    function anims(rate) {
      if (!st.getAnimations) return;
      st.getAnimations({ subtree: true }).forEach(function (a) {
        var t = a.effect && a.effect.getTiming ? a.effect.getTiming() : null;
        if (t && t.iterations !== Infinity) a.playbackRate = rate;
      });
    }
    function start() {
      if (playing || done) return;
      playing = true; last = 0; st.setAttribute('data-hx', 'play'); request();
      void st.offsetWidth; hurry(2.2); // the arrival plays in under 2s instead of 8.6s: the title is readable almost at once
      guard = setInterval(function () {
        var now = window.performance ? performance.now() : Date.now();
        if (playing && now - lastStep > 350) step(now);
        if (!playing) clearInterval(guard);
      }, 400);
    }
    function finish() {
      T = Math.max(T, END); playing = false; done = true; clearInterval(guard);
      var skipBtn = st.querySelector('.hx-skip'), hadFocus = skipBtn && document.activeElement === skipBtn;
      st.setAttribute('data-hx', 'done'); setTimeout(function () { ambient(true); }, 250);
      if (hadFocus) { var cue = st.querySelector('.hx-cue'), h1 = st.querySelector('.hx-h'); // keep keyboard focus somewhere visible
        if (cue && cue.offsetParent) cue.focus({ preventScroll: true }); else if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); } }
    }
    function hurry(rate) { if (!playing || speed >= rate) return; speed = rate; anims(rate); }

    measure();
    if (reduce) { st.setAttribute('data-hx', 'done'); request(); }
    else st.setAttribute('data-hx', 'wait');
    // after the arrival the stone stays alive: now and then light runs along the fracture, and crosses the crystal
    var overW = false, gT = 0, nAmb = 0;
    function glint() { if (reduce || !done || gT) return; st.setAttribute('data-glint', ''); gT = setTimeout(function () { st.removeAttribute('data-glint'); gT = 0; }, 2300); }
    function seen() { var r = st.getBoundingClientRect(); return !document.hidden && r.bottom > 0 && r.top < innerHeight && q < 0.3; }
    function ambient(first) {
      if (reduce || !done || !seen()) return;
      var c = first ? cracks[0] : cracks[[0, 1, 3, 4][Math.floor(pr() * 4)]], n = c.lastN || c.N - 1;
      var i = Math.floor((first ? 0.48 : 0.15 + pr() * 0.75) * n);
      pulses.push({ x: ax + c.x[i] * U * sx, y: ay + c.y[i] * U, t: 0, a: first ? 1 : 0.8 }); request();
      if (++nAmb % 3 === 0) glint();
    }
    var ambT = reduce ? 0 : setInterval(ambient, 5600);
    var ro = window.ResizeObserver ? new ResizeObserver(function () { measure(); request(); }) : null;
    var onR = function () { measure(); request(); };
    if (ro) ro.observe(st); else window.addEventListener('resize', onR);
    st.addEventListener('pointermove', onMove, { passive: true });
    st.addEventListener('pointerleave', onLeave, { passive: true });
    st.addEventListener('pointerdown', onDown, { passive: true });
    return {
      scroll: function () { if (playing && prog() > 0.002) hurry(4); request(); },
      skip: function () { if (!playing) { if (!done) { start(); } } hurry(10); request(); },
      seek: function (t, qq) { // deterministic frame for review tooling: pause the clock at t seconds
        playing = false; T = t; if (T < END) st.setAttribute('data-hx', 'play');
        if (st.getAnimations) st.getAnimations({ subtree: true }).forEach(function (a) { a.pause(); a.currentTime = t * 1000; });
        if (qq != null) q = qq; draw();
      },
      start: start, glint: glint,
      stone: function (k) { // swap the stone in the fracture, and send light along it as it changes
        if (k === cur || !SRC[k]) return; prev = cur; cur = k; mix = reduce ? 1 : 0; cacheOk = false;
        if (!reduce) [0.3, 0.55, 0.8].forEach(function (f, j) { var c = cracks[j === 1 ? 3 : 0], n = c.lastN || c.N - 1, i = Math.floor(f * n); pulses.push({ x: ax + c.x[i] * U * sx, y: ay + c.y[i] * U, t: -0.12 * j, a: 1.4 }); });
        request();
      },
      state: function () { return { T: T, q: q, playing: playing, done: done, lite: lite }; },
      destroy: function () { clearInterval(guard); clearInterval(ambT); if (raf) cancelAnimationFrame(raf); st.removeEventListener('pointermove', onMove); st.removeEventListener('pointerleave', onLeave); st.removeEventListener('pointerdown', onDown); if (ro) ro.disconnect(); else window.removeEventListener('resize', onR); }
    };
  }
  return { mount: mount };
})();

A.section('hero', hx => {
  const { $, $$, reduce, fine, onFrame, edName, pickStone, onStone } = A;
  const hxSt = $('.hx-stage', hx); if (!hxSt) return;
  const hxEl = { track: hx, stage: hxSt };
  ['cam', 'stone', 'torch', 'glow', 'crack', 'wlayer', 'anchor', 'wrap', 'watch', 'copy'].forEach(k => { hxEl[k] = $('.hx-' + k, hxSt); });
  hxEl.stone = $('.hx-stone', hxSt);
  // the title arrives letter by letter; screen readers keep the words
  const h1 = $('.hx-h', hx);
  if (h1) {
    h1.setAttribute('aria-label', h1.textContent.replace(/\s+/g, ' ').trim());
    $$('.hx-h>span', hx).forEach((l, j) => { const t = l.textContent; l.setAttribute('aria-hidden', 'true'); l.textContent = ''; [...t].forEach((c, i) => { const e = document.createElement('span'); e.className = 'ch'; e.textContent = c; e.style.setProperty('--i', j * 5 + i); l.appendChild(e); }); });
  }
  let hero = null;
  const still = hxSt.hasAttribute('data-hero-image'); // a photograph instead of the stone and watch: no canvas, no arrival
  if (still) hxSt.setAttribute('data-hx', 'done');
  else try {
    const conn = navigator.connection || {};
    hero = HERO.mount(hxEl, { reduce, lite: !!conn.saveData || (navigator.hardwareConcurrency > 0 && navigator.hardwareConcurrency <= 2), charoite: hxSt.dataset.texCha, obsidian: hxSt.dataset.texObs });
  } catch (err) { console.error('[atelier] hero', err); hxSt.setAttribute('data-hx', 'done'); }
  const skip = $('.hx-skip', hx); if (skip) skip.addEventListener('click', () => { if (hero) hero.skip(); });
  const hsw = $$('[data-hs]', hx), hit = $('.hx-hit', hx); let swT = 0;
  // the button opens the Klaviyo form of the edition on show
  const cta = $('.hx-cta[data-klaviyo-form]', hx);
  function ctaForm(k) { if (!cta) return; const id = cta.getAttribute('data-klaviyo-' + k) || cta.getAttribute('data-klaviyo-cha') || cta.getAttribute('data-klaviyo-form'); if (id) cta.setAttribute('data-klaviyo-form', id); }
  // without the edition switch there is nothing to choose: the sign-up goes to the "Both" list (or the one set on the block)
  const hasSwitch = hsw.length > 0;
  const edition = () => hasSwitch ? (hxSt.dataset.st || 'cha') : ((sCfg && sCfg.dataset.default) || 'both');
  ctaForm(hasSwitch ? (hxSt.dataset.st || 'cha') : 'both');
  // email sign-up in place of the button: to a Klaviyo list, or to Shopify's customer form, for the edition on show
  const sf = $('.hx-form', hx), sMsg = $('.hx-form-msg[aria-live]', hx), sSync = $('.hx-form-sync', hx);
  const sCfg = sf && sf.hasAttribute('data-klaviyo-key') ? sf : sSync; // Klaviyo config sits on the form, Shopify's beside it
  const tagInput = sf ? $('input[name="contact[tags]"]', sf) : null;
  function syncSignup(k) { if (tagInput) { const t = tagInput.getAttribute('data-tag-' + k) || tagInput.getAttribute('data-tag-cha'); if (t) tagInput.value = t; } }
  syncSignup(edition());
  if (sf) {
    const mail = $('input[type="email"]', sf);
    const say = (t, kind) => { if (!sMsg) return; sMsg.textContent = t || ''; if (kind) sMsg.dataset.kind = kind; else delete sMsg.dataset.kind; };
    if (mail) mail.addEventListener('input', () => { mail.removeAttribute('aria-invalid'); say(''); });
    sf.addEventListener('submit', async e => {
      const v = mail ? mail.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { e.preventDefault(); if (mail) { mail.setAttribute('aria-invalid', 'true'); mail.focus(); } say(sCfg && sCfg.dataset.error, 'error'); return; }
      const lead = sCfg ? sCfg.getAttribute('data-lead') : null, on = sCfg ? sCfg.getAttribute('data-lead-on') : 'click', pixel = sCfg ? (sCfg.getAttribute('data-lead-pixel') || '') : '';
      if (lead !== null && on !== 'submit') A.fbLead(lead, pixel);
      const key = sf.getAttribute('data-klaviyo-key');
      if (key === null) return; // Shopify customer form: posts as usual
      e.preventDefault();
      const k = edition(), list = sf.getAttribute('data-list-' + k) || sf.getAttribute('data-list-cha');
      if (!key || !list) { console.error('[atelier] hero sign-up: Klaviyo public key or list ID missing'); say(sf.dataset.error, 'error'); return; }
      sf.setAttribute('data-busy', '');
      try {
        const body = { data: { type: 'subscription', attributes: { custom_source: sf.dataset.source || 'Atelier hero', profile: { data: { type: 'profile', attributes: { email: v, properties: { 'L1T edition': k } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
        const r = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body) });
        if (!r.ok) throw new Error('Klaviyo responded ' + r.status);
        say(sf.dataset.success, 'ok'); if (mail) mail.value = '';
        if (lead !== null && on === 'submit') A.fbLead(lead, pixel);
      } catch (err) { console.error('[atelier] hero sign-up', err); say(sf.dataset.error, 'error'); }
      sf.removeAttribute('data-busy');
    });
  }
  // the caption: its own line for Both, the edition name otherwise
  const cap = $('.hx-cap', hx), capHTML = cap ? cap.innerHTML : '';
  const bump = el => { el.removeAttribute('data-swap'); void el.offsetWidth; if (!reduce) el.dataset.swap = ''; };
  function caption(k) {
    if (!cap) return; const both = cap.getAttribute('data-caption-both');
    if (k === 'both' && both) { if (cap.textContent !== both) { cap.textContent = both; bump(cap); } return; }
    if (!cap.querySelector('.hx-ed')) { cap.innerHTML = capHTML; bump(cap); }
    edName($('.hx-ed', cap), k);
  }
  function heroStone(k) {
    ctaForm(k); syncSignup(k);
    if (hxSt.dataset.st === k || (!hxSt.dataset.st && k === 'cha')) return;
    caption(k);
    hxSt.dataset.st = k; hsw.forEach(b => b.setAttribute('aria-pressed', b.dataset.hs === k ? 'true' : 'false'));
    if (hit && hit.getAttribute('data-label-' + k)) hit.setAttribute('aria-label', hit.getAttribute('data-label-' + k));
    if (!reduce) { hxSt.removeAttribute('data-swap'); void hxSt.offsetWidth; hxSt.dataset.swap = ''; clearTimeout(swT); swT = setTimeout(() => hxSt.removeAttribute('data-swap'), 1300); }
    if (hero) hero.stone(k);
  }
  hsw.forEach(b => b.addEventListener('click', () => { heroStone(b.dataset.hs); pickStone(b.dataset.hs, 'hero'); }));
  const offStone = onStone((k, from) => { if (from !== 'hero') heroStone(k); });
  if (hit) {
    hit.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && hxSt.dataset.hx === 'done') { hxSt.dataset.wh = ''; if (hero) hero.glint(); } });
    hit.addEventListener('pointerleave', () => { delete hxSt.dataset.wh; });
    hit.addEventListener('click', () => pickStone(hxSt.dataset.st || 'cha', 'hero'));
  }
  // the title leans toward the hand: letters near the pointer rise a little and take the stone's colour
  const chs = $$('.hx-h .ch', hx); let chRaf = 0, cpx = -1e4, cpy = -1e4;
  const lean = () => { chRaf = 0; if (hxSt.dataset.hx !== 'done') return; chs.forEach(c => { const r = c.getBoundingClientRect(), d = Math.hypot(r.left + r.width / 2 - cpx, r.top + r.height / 2 - cpy), k = Math.max(0, 1 - d / 220); c.style.setProperty('--k', (k * k).toFixed(3)); }); };
  if (fine && !reduce && !still) { hxSt.addEventListener('pointermove', e => { cpx = e.clientX; cpy = e.clientY; if (!chRaf) chRaf = requestAnimationFrame(lean); }, { passive: true }); hxSt.addEventListener('pointerleave', () => { cpx = cpy = -1e4; if (!chRaf) chRaf = requestAnimationFrame(lean); }); }
  // countdown: the moment comes from the section setting (ISO date, ideally with a time-zone offset)
  const cd = $('.hx-cd', hx); let cdT = 0;
  if (cd) {
    const raw = (cd.dataset.until || '').trim().replace(' ', 'T'), until = new Date(raw).getTime();
    const num = { d: $('[data-cd="d"]', cd), h: $('[data-cd="h"]', cd), m: $('[data-cd="m"]', cd), s: $('[data-cd="s"]', cd) };
    const pad = n => (n < 10 ? '0' : '') + n;
    const tick = () => {
      let left = until - Date.now();
      if (left <= 0) { if (cd.hasAttribute('data-hide-done')) cd.hidden = true; else cd.setAttribute('data-done', ''); clearInterval(cdT); return; }
      left = Math.floor(left / 1000);
      const d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      if (num.d) num.d.textContent = pad(d); if (num.h) num.h.textContent = pad(h); if (num.m) num.m.textContent = pad(m); if (num.s) num.s.textContent = pad(sec);
    };
    if (isNaN(until)) cd.hidden = true; else { tick(); cdT = setInterval(tick, cd.hasAttribute('data-no-seconds') ? 15000 : 1000); }
  }
  const off = onFrame(() => { if (hero) hero.scroll(); });
  const t0 = setTimeout(() => { if (hero) hero.start(); }, 60);
  return () => { off(); offStone(); clearTimeout(t0); clearInterval(cdT); if (hero) hero.destroy(); };
});
